<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <h1 class="mb-3">New Report</h1>
    <ReportForm :report="report" />
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ReportForm from "@/components/ReportForm";

export default {
  components: {
    ReportForm
  },

  methods: {
    ...mapActions({ fetchReport: "report/fetchReport" })
  },
  computed: {
    ...mapGetters({ report: "report/getreport", project: "project/data" }),
    breadcrumbs() {
      return [
        {
          html: "<i class='fas fa-home'></i>",
          to: { name: "home" }
        },
        {
          text: this.project.title,
          to: { name: "project", params: { uuid: this.project.id } }
        },
        {
          text: "Reports",
          to: { name: "reports", params: { uuid: this.project.id } }
        },
        {
          text: "New Repor",
          to: { name: "createReport" },
          active: true
        }
      ];
    }
  },
  mounted() {
    this.fetchReport(this.$route.params.id);
  }
};
</script>

<style>
</style>